import { datePresets, datePresetsTranslations } from 'components/common-form/sidePanel/backTest/shared';
import { DatePicker } from 'components/shared/DatePicker/DatePicker';
import { nowISODate } from 'state/backTest/backTest.model';

type RangePickerProps = {
  setMaturities: (maturities: string[]) => void;
  maturities: readonly string[];
  disabled?: boolean;
};
export function RangePicker({ setMaturities, maturities, disabled = false }: RangePickerProps) {
  return (
    <>
      <DatePicker
        disabled={disabled}
        id="startRangeDate"
        className="me-1"
        allowWeekend
        type="mono"
        maxDate={maturities[1]}
        datePresets={datePresets}
        datePresetTranslations={datePresetsTranslations}
        values={[maturities[0]]}
        isClearable={false}
        onChange={date => {
          if (date) {
            setMaturities([date, maturities[1]]);
          }
        }}
      ></DatePicker>
      <DatePicker
        disabled={disabled}
        className="ms-1"
        id="endRangeDate"
        allowWeekend
        align="end"
        type="mono"
        minDate={maturities[0]}
        maxDate={nowISODate}
        datePresets={datePresets}
        datePresetTranslations={datePresetsTranslations}
        values={[maturities[1]]}
        isClearable={false}
        onChange={date => {
          if (date) {
            setMaturities([maturities[0], date]);
          }
        }}
      ></DatePicker>
    </>
  );
}
